module.exports = __webpack_public_path__ + "static/media/dont1.a6c40acc.png";